import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateUser = (params) => {
    return axios.post(`${backendHost}/api/admin/cashiers/users`, params);
};

export {
    postCreateUser
}